import { render } from "./StepIndicator.vue?vue&type=template&id=b4df8c0a&scoped=true"
import script from "./StepIndicator.vue?vue&type=script&lang=ts"
export * from "./StepIndicator.vue?vue&type=script&lang=ts"

import "./StepIndicator.vue?vue&type=style&index=0&id=b4df8c0a&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-b4df8c0a"
/* custom blocks */
import block0 from "./StepIndicator.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script